import axios from "axios";

export async function todayEspont() {
  let espont = {
    sima: 0,
    dupla: 0,
  };
  try {
    const response = await axios.get(
      "https://api.palinagyonbuzi.com/api/espont/osztas",
    );
    espont.sima = response.data.sima;
    espont.dupla = response.data.dupla;
  } catch (error) {
    console.error("Error fetching data:", error);
    espont.sima = 0;
    espont.dupla = 0;
  }

  return espont;
}

export async function TopEspont() {
  try {
    const response = await axios.get(
      "https://api.palinagyonbuzi.com/api/espont/top",
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching data:", error);
    return { username: "N/A", espont: 0 };
  }
}

export async function getBanner() {
  try {
    const response = await axios.get(
      "https://api.palinagyonbuzi.com/api/overlay",
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching data:", error);
  }
}
